import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output, inject } from "@angular/core";
import { IButtonDirective, IIconComponent, ITooltipDirective } from "@front/m19-ui";
import { TranslocoDirective, TranslocoService } from "@jsverse/transloco";

@Component({
  selector: "app-export-button",
  template: ` <button
    *transloco="let t"
    iButton
    variant="secondary"
    [iTooltip]="tooltipValue"
    (click)="handleClick($event)"
  >
    <IIcon name="upload" />
    {{ t("common.export") }}
  </button>`,
  imports: [IButtonDirective, ITooltipDirective, TranslocoDirective, IIconComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ExportButtonComponent implements OnInit {
  private translocoService = inject(TranslocoService);

  @Input() tooltipValue: string = "";
  @Output() export = new EventEmitter<Event>();

  ngOnInit(): void {
    if (this.tooltipValue === undefined) {
      this.tooltipValue = this.translocoService.translate("common.export_as_csv");
    }
  }

  handleClick(event: MouseEvent) {
    this.export.emit(event);
  }
}
